import React from "react";
import PropTypes from "prop-types";
import PartNumber from "MODULES/shared/components/PartNumber";
import { shortDateYY } from "LIB/formatters/date";

export default function Item({ destroy, item, pushHistory }) {
  const { description, id, uuid } = item.part;
  const handleDelete = e => {
    e.stopPropagation();
    destroy(id);
  };

  const handleClick = e => {
    e.preventDefault();
    pushHistory(uuid);
  };

  return (
    <li className="cart-item cursor">
      <a onClick={handleClick}>
        <table className="table" style={{ marginBottom: 0 }}>
          <tbody>
            <tr>
              <td>
                <PartNumber part={item.part} statsTooltip={false} />{" "}
              </td>
              <td className="text-right">{shortDateYY(item.created_at)}</td>
              <td className="td-shrink">
                <button
                  type="button"
                  className="close"
                  aria-label="Delete"
                  onClick={handleDelete}
                >
                  <span>
                    <i className="fa fa-close fa-sm" />
                  </span>
                </button>
              </td>
            </tr>
            <tr>
              <td colSpan={3} className="text-center">
                <em className="text-muted">{description}</em>
              </td>
            </tr>
          </tbody>
        </table>
      </a>
    </li>
  );
}

Item.propTypes = {
  item: PropTypes.shape({
    part: PropTypes.shape({
      id: PropTypes.number,
      description: PropTypes.string.isRequired,
      part_number: PropTypes.string.isRequired
    })
  }),
  destroy: PropTypes.func.isRequired,
  pushHistory: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/Nav/BookmarkedParts/Item.jsx